import { render, staticRenderFns } from "./expansion.panel.component.vue?vue&type=template&id=8cca8480&scoped=true&lang=pug"
import script from "./expansion.panel.component.vue?vue&type=script&lang=ts"
export * from "./expansion.panel.component.vue?vue&type=script&lang=ts"
import style0 from "./expansion.panel.component.vue?vue&type=style&index=0&id=8cca8480&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cca8480",
  null
  
)

export default component.exports